import { deviceType } from '@/utils/tools'

export const getUserInfo = (block) => {
  // if (process.env.NODE_ENV === 'development') {
  //   block({
  //     user: {
  //       token: '0dbf50d6e06e1880639fef3a68fae3f0',
  //       is_main: 1,
  //       merchant: {
  //         id: 11,
  //         fixed: 1,
  //         goodsId: 1
  //       }
  //     },
  //     isBeta: true
  //   })
  //   return true
  // }
  let httpUserInfoBlock = 'httpUserInfoBlock' + Math.ceil(Math.random() * 10)
  if (deviceType()) {
    let userJson = window.AndroidNative.JD_GetUserInfo(null)
    block(JSON.parse(userJson))
  } else {
    window[httpUserInfoBlock] = block
    let prms = JSON.stringify({
      param: {},
      block: httpUserInfoBlock
    })
    window.webkit.messageHandlers.JD_GetUserInfo.postMessage(prms)
  }
}
export const clearCache = () => {
  if (deviceType()) {
    window.AndroidNative.JD_ClearCache(null)
  } else {
    window.webkit.messageHandlers.JD_ClearCache.postMessage(null)
  }
}
export const logout = () => {
  if (deviceType()) {
    window.AndroidNative.JD_LoginOut(JSON.stringify(null))
  } else {
    window.webkit.messageHandlers.JD_LoginOut.postMessage(JSON.stringify(null))
  }
}

const agreePolicy = (val) => {
  if (process.env.NODE_ENV === 'development') {
    return true
  }
  if (deviceType()) {
    window.AndroidNative.JD_AgreePolicy(val)
  } else {
    window.webkit.messageHandlers.JD_AgreePolicy.postMessage(val)
  }
}

const getCacheSize = (block) => {
  if (process.env.NODE_ENV === 'development') {
    return true
  }
  if (deviceType()) {
    let json = window.AndroidNative.JD_GetCacheSize(null)
    block(JSON.parse(json))
  } else {
    window.getCacheSizeBlock = block
    let params = JSON.stringify({
      block: 'getCacheSizeBlock'
    })
    window.webkit.messageHandlers.JD_GetCacheSize.postMessage(params)
  }
}
const getPlatFromInfo = (block) => {
  if (deviceType()) {
    let json = window.AndroidNative.JD_GetPlatformInfo()
    block(JSON.parse(json))
  } else {
    window.getPlatformInfoBlock = block
    let params = JSON.stringify({
      block: 'getPlatformInfoBlock'
    })
    window.webkit.messageHandlers.JD_GetPlatformInfo.postMessage(params)
  }
}

export default {
  getUserInfo,
  clearCache,
  logout,
  agreePolicy,
  getCacheSize,
  getPlatFromInfo
}
